import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/eva-icons/eva-icons.css'
import '@quasar/extras/ionicons-v4/ionicons-v4.css'
import 'antd/dist/antd.css';
import './Assets/css/base.scss';
import Chart from 'chart.js/auto';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store'
import { Provider } from 'react-redux';
import disableDevtool from 'disable-devtool';

disableDevtool({
  ondevtoolclose: () => {
    alert("Dev tools are not allowed in this tab!")
    window.close()
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
